module.exports = __webpack_public_path__ + "static/logo_generali_nb-e037d92109f526fc077fd7511ee0310e.svg";